// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YCIxf2UhxY9qSs {
  margin: 24px 0 32px;
}
.YCIxf2UhxY9qSs .naGcrWO3wC0kgL {
  margin-left: 5px;
}
.YCIxf2UhxY9qSs a {
  margin: 0 10px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orgGuestSection": `YCIxf2UhxY9qSs`,
	"headingIcon": `naGcrWO3wC0kgL`
};
export default ___CSS_LOADER_EXPORT___;
